import React from 'react';
import { Loader2, Upload } from 'lucide-react';
import { Button } from '../../../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../../ui/dialog';

export const BulkCsvPriceDialog = ({ open, onOpenChange, file, onFileChange, result, onUpload, saving }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg" data-testid="bulk-csv-price-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Upload className="w-5 h-5 text-amber-600" /> Bulk Price Import (CSV)
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <p className="text-sm text-neutral-500">Upload a CSV file to set material prices across all collections at once.</p>
        <div className="border-2 border-dashed border-neutral-300 rounded-lg p-6 text-center hover:border-amber-400 transition-colors">
          <input type="file" accept=".csv" onChange={(e) => onFileChange(e.target.files[0])} className="hidden" id="bulk-csv-input" data-testid="bulk-csv-file-input" />
          <label htmlFor="bulk-csv-input" className="cursor-pointer">
            <Upload className="w-8 h-8 mx-auto mb-2 text-neutral-400" />
            {file ? <p className="text-sm font-medium text-amber-700">{file.name}</p> : <p className="text-sm text-neutral-500">Click to select CSV file</p>}
          </label>
        </div>
        <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-3">
          <p className="text-xs font-medium text-neutral-700 mb-1">CSV Format:</p>
          <code className="text-[11px] text-neutral-600 block leading-relaxed">
            material_name, base_price<br />
            Aspen, 12.99<br />
            Berlin, 14.50<br />
            <span className="text-neutral-400">— or with collection filter —</span><br />
            collection_name, material_name, base_price<br />
            Black-Out, Aspen, 12.99
          </code>
        </div>
        {result && (
          <div className={`p-3 rounded-lg ${result.errors?.length ? 'bg-amber-50 border border-amber-200' : 'bg-green-50 border border-green-200'}`} data-testid="bulk-csv-result">
            <p className="text-sm font-medium text-green-700">Updated {result.updated_materials} materials</p>
            {result.errors?.length > 0 && (
              <div className="mt-2">
                <p className="text-xs text-amber-700 font-medium">Errors:</p>
                {result.errors.map((err, i) => <p key={i} className="text-xs text-amber-600">{err}</p>)}
              </div>
            )}
          </div>
        )}
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Close</Button>
        <Button onClick={onUpload} disabled={saving || !file} className="bg-amber-600 hover:bg-amber-700" data-testid="bulk-csv-upload-btn">
          {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Upload className="w-4 h-4 mr-2" />}
          Upload & Apply
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default BulkCsvPriceDialog;
